import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { getDetailSeizure, updateStatusTransition } from 'services/files';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { FormDataSeizure } from '../../../SeizureReportsPage/hooks';
import { Lead, TFile } from 'types/user';

export type SeizureFile = {
  url: string;
  name: string;
  id: string;
  storageId: string;
};

type Location = {
  value: string;
};

interface TSeizureDetails extends FormDataSeizure {
  fileId?: string;
  signedVsa: boolean;
  addressLead: {
    id: number;
    address: string;
  };
  file: TFile & {
    fileStatusTransition: { status: string }[];
    filePostSeizures: {
      id: number;
    }[];
    leads: Lead[];
  };
  vsaDocuments: SeizureFile[];
  seizureReportPhotos: SeizureFile[];
  removedToLocation?: Location;
  createdAt?: string;
}

export const useSeizureDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dataDetail, setDataDetail] = useState<TSeizureDetails>();

  const fetchDetailSeizure = useCallback(async () => {
    const { seizureReport } = await getDetailSeizure(Number(id));
    setDataDetail(seizureReport);
  }, [id]);

  const { asyncCallback: asyncFetchDetailSeizure } = useAsyncCallback(fetchDetailSeizure, []);

  useEffect(() => {
    asyncFetchDetailSeizure();
  }, [id]);

  const handleOnBack = () => navigate(-1);

  const handleOnClick = async () => {
    await updateStatusTransition(Number(dataDetail?.fileId), 'POST_SEIZURE');
    if (dataDetail?.file.filePostSeizures?.length) {
      return navigate(
        `/admin/redemptions/post-seizure/edit/${dataDetail?.file.filePostSeizures[0]?.id}`
      );
    }
    navigate(`/admin/redemptions/post-seizure/create?fileId=${dataDetail?.fileId}`);
  };
  const { asyncCallback: asyncHandleOnClick } = useAsyncCallback(handleOnClick, []);
  return {
    dataDetail,
    handleOnClick: asyncHandleOnClick,
    handleOnBack
  };
};
